const DIALOG_SEARCH_PARAMS_EVENT = 'snippets-dialog-searchparams-change';

function hasWindow() {
  return typeof window !== 'undefined';
}

function buildNextUrl(params) {
  const search = params.toString();
  const base = `${window.location.pathname}${search ? `?${search}` : ''}`;
  return `${base}${window.location.hash || ''}`;
}

export function readSearchParam(name) {
  if (!hasWindow()) {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

export function updateDialogSearchParams(mutateParams, push = false) {
  if (!hasWindow()) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  mutateParams(params);

  const nextUrl = buildNextUrl(params);
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash || ''}`;

  if (nextUrl !== currentUrl) {
    if (push) {
      window.history.pushState(window.history.state, '', nextUrl);
    } else {
      window.history.replaceState(window.history.state, '', nextUrl);
    }
  }

  window.dispatchEvent(new Event(DIALOG_SEARCH_PARAMS_EVENT));
}

export function subscribeToDialogSearchParamsChange(handler) {
  if (!hasWindow()) {
    return () => {};
  }

  window.addEventListener('popstate', handler);
  window.addEventListener(DIALOG_SEARCH_PARAMS_EVENT, handler);

  return () => {
    window.removeEventListener('popstate', handler);
    window.removeEventListener(DIALOG_SEARCH_PARAMS_EVENT, handler);
  };
}
